<template>
    <div class="highRebate area">
        <div class="gameRecordTitle">
            <span @click="backPage" :class="{colorBlack:rulesShow}">{{$t('highRebate.title')}}</span>
            <div class="titleRight" v-show="rulesShow">
                <i></i>
                <span>{{title}}</span>
            </div>
        </div>

        <div v-show="!rulesShow">
            <!-- 领取部分 -->
            <div class="receivePart">
                <div class="headerLeft">
                    <div class="receivePartLeft">
                        <div>
                            <div class="text1">
                                <span class="textLeft">{{$t('highRebate.text1')}}</span>
                                <span class="textRight">{{amount}}{{$t('highRebate.text2')}}</span>
                            </div>
                            <div class="text2">{{$t('highRebate.text3')}}{{minCount}}{{$t('highRebate.getConditions2')}}{{meetConditions}}{{$t('highRebate.getConditions3')}}</div>
                        </div>
                    </div>
                    <span class="receive" @click="getReceive">{{$t('highRebate.text5')}}</span>
                </div>
                <div class="headerRight">
                    <div class="VipNum" @click="toVip()">
                        <span class="VipNumLeft">{{$t('highRebate.text6')}}({{$t('highRebate.Vnum')}}{{Vnum}},{{$t('highRebate.effectiveVnum')}}{{effectiveVnum}})</span>
                        <i></i>
                    </div>
                </div>
                
            </div>

            <div class="qrCode">

                <div class="item">
                    <div class="bgcwhite">
                        <div class="bgcBorder">
                            <span id="qrcode"></span>
                        </div>
                        <span class="text1">{{$t('highRebate.text7')}}</span>
                    </div>
                    <span class="qrcodeButton" @click="download">{{$t('highRebate.text8')}}</span>
                </div>

                <div class="item">
                    <div class="bgcwhite">
                        <div class="bgcBorder InviteCode">{{inviteCode}}</div>
                        <span class="text1">{{$t('highRebate.text9')}}</span>
                    </div>
                    <span class="qrcodeButton" v-clipboard:copy="inviteCode"
                            v-clipboard:success="(type) => onCopyResult('success')"
                            v-clipboard:error="(type) => onCopyResult('error')">{{$t('highRebate.text10')}}</span>
                </div>

                <div class="item">
                    <div class="bgcwhite">
                        <div class="bgcBorder address">
                            {{promoteAddress}}
                        </div>
                        <span class="text1">{{$t('highRebate.text11')}}</span>
                    </div>
                    <span class="qrcodeButton" v-clipboard:copy="promoteAddress"
                            v-clipboard:success="(type) => onCopyResult('success')"
                            v-clipboard:error="(type) => onCopyResult('error')">{{$t('highRebate.text12')}}</span>
                </div>

            </div>

            <div class="rules" @click="toRules()">
                <span class="rulesLeft">{{$t('highRebate.text13')}}</span>
                <i></i>
            </div>
        </div>

        <div v-show="rulesShow && title === $t('highRebate.text13')" style="margin-top:57px;">
            <div v-html="rules" class="rulesDetails"></div>
        </div>

        <!-- 邀请会员 -->
        <div v-show="rulesShow && title === $t('highRebate.text14')">
            <div>
                <div class="totalBet">
                    <span class="totalBetLeft">{{$t('highRebate.text15')}}￥{{totalBetValid}}</span>
                    <span class="totalBetRight">{{$t('highRebate.text16')}}￥{{totalAllowance}}</span>
                </div>
                <el-form ref="form" :model="form">

                    <el-form-item :label="$t('highRebate.text17')" style="margin-bottom:37px;">
                        <div class="transactionStyle">
                            <span v-for="(item,index) in dateTime" :key="index" @click="chooseTime(item)" :class="{buttonColor:item.id === chooseDateId}">{{item.name}}</span>
                        </div>
                    </el-form-item>

                    <el-form-item :label="$t('highRebate.text18')" class="record">
                        <div class="inputWidth">
                            <el-date-picker type="date" :editable="false" :placeholder="$t('record.text1')" v-model="form.startTime" style="width: 100%;"></el-date-picker>
                        </div>
                        <el-col class="line" :span="1"></el-col>
                        <div class="inputWidth">
                            <el-date-picker type="date" :editable="false" :placeholder="$t('record.text1')" v-model="form.endTime" style="width: 100%;"></el-date-picker>
                        </div>
                        <div class="button">
                            <span class="query" @click="query(1)">{{$t('record.text2')}}</span>
                            <span class="reset" @click="reset">{{$t('record.text3')}}</span>
                        </div>
                    </el-form-item>

                </el-form>


                <el-table :data="tableData" style="width: 100%" v-show="tableData.length > 0" height="450">
                    <el-table-column prop="memberName" :label="$t('highRebate.text19')" align="center"></el-table-column>
                    <el-table-column prop="registerDate" :label="$t('highRebate.text20')" align="center"></el-table-column>
                    <el-table-column prop="validAmount" :label="$t('highRebate.text21')" align="center"></el-table-column>
                    <el-table-column prop="allowance" :label="$t('highRebate.text22')" align="center"></el-table-column>
                </el-table>

                <div class="null" v-show="tableData.length === 0" style="height:450px;max-height: 450px;">
                    <img loading="lazy" class="nullImg" v-lazy="require('../../../assets/images/xf/null.png')" alt="">
                    <p class="nullText">{{$t('record.text4')}}</p>
                </div>

                <div class="borderBottom"></div>

                <div class="pagination">
                    <el-pagination small layout="prev, pager, next" :pageSize="10" @current-change="query" :total="total" :current-page.sync="currentPage"></el-pagination>
                </div>

            </div>
        </div>


        <el-dialog class="receive" :visible.sync="dialogVisible" width="4.26rem" :before-close="handleClose" :show-close="false" style="border-radius: 0.1rem;">
            <span class="title">{{$t('highRebate.text23')}}</span>
            <img loading="lazy" class="dialogClose" v-lazy="require('../../../assets/images/xf/close.png')" style="cursor: pointer;" @click="handleClose" />
            <div>
                <p class="p1">{{amount}}{{$t('highRebate.text24')}}</p>
                <p class="p2">{{$t('highRebate.text25')}}{{ultiple}}{{$t('highRebate.text26')}}</p>
            </div>
            <span class="footer-button">
                <el-button @click="cancel()" class="button-left">{{$t('highRebate.text27')}}</el-button>
                <el-button type="primary" @click="determine()" class="button-right">{{$t('highRebate.text28')}}</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import QRCode from '@keeex/qrcodejs-kx';
export default {
    components: {
        // eslint-disable-next-line vue/no-unused-components
        QRCode,
    },
    data() {
        return {
            qrCode: '',// 二维码
            inviteCode: '',// 邀请码
            promoteAddress: '',// 推广地址
            minCount: '--/--',
            amount: '--/--',
            ultiple: '0',
            dialogVisible: false,
            receiveFalse: false,
            Vnum: '0',
            effectiveVnum:'0',
            meetConditions:'0',
            maxReceive:'0',
            rules: '',
            rulesShow: false,
            title: '',
            key: 'value',
            form: {
                startTime: '',
                endTime: '',
                fixedStartTime: '',
                fixedEndTime: '',
            },
            dateTime: [
                {
                    name: this.$t('tradingRecord.text46'),
                    id: 1,
                },
                {
                    name: this.$t('tradingRecord.text47'),
                    id: 2,
                },
                {
                    name: this.$t('tradingRecord.text48'),
                    id: 3,
                },
                {
                    name: this.$t('tradingRecord.text49'),
                    id: 4,
                },
            ],
            chooseDateId: -1,
            totalBetValid: '0.00',
            totalAllowance: '0.00',
            total:1,
            currentPage:1,
            tableData: [],
            nothingShow:false,

        }
    },
    created() {
        this.referralLink();
        this.validMemberCount();
    },
    methods: {
        init(){
            this.rulesShow = false;
        },
        onCopyResultBetNo(type) {
            if (type === 'success') {
                this.$message({
                    message: this.$t('record.text5'),
                    type: 'success',
                })
            } else {
                this.$message({
                    message: this.$t('record.text6'),
                    type: 'error',
                })
            }
        },
        handleClose() {
            this.dialogVisible = false;
        },
        chooseTime(item) {
            if (item.id != this.chooseDateId) {
                this.chooseDateId = item.id;
                this.form.startTime = '';
                this.form.endTime = '';
                this.form.fixedStartTime = '';
                this.form.fixedEndTime = '';
            } else {
                this.chooseDateId = -1;
                this.form.startTime = '';
                this.form.endTime = '';
                this.form.fixedStartTime = '';
                this.form.fixedEndTime = '';
            }

        },
        mask(str,begin) {
            var fstStr = str.substring(0,begin);
            var scdStr = str.substring(str.length - 1,str.length);
            return `${fstStr}****${scdStr}`;
        },
        reset(){
            this.form.startTime = '';
            this.form.endTime = '';
            this.chooseDateId = -1;
        },
        query(val = 1) {
            let that = this;
            that.currentPage = val;
            let form = {...that.form};
            switch (that.chooseDateId) {
                // 今日
                case 1:
                    form.fixedStartTime = that.$common.dateTime(0)[0];
                    form.fixedEndTime = that.$common.dateTime(0)[1];
                    break;
                    // 昨日
                case 2:
                    form.fixedStartTime = that.$common.dateTime(1)[0];
                    form.fixedEndTime = that.$common.dateTime(1)[1];
                    break;
                    // 近7日
                case 3:
                    form.fixedStartTime = that.$common.dateTime(6)[0];
                    form.fixedEndTime = that.$common.dateTime(6)[1];
                    break;
                    // 近30日
                case 4:
                    form.fixedStartTime = that.$common.dateTime(29)[0];
                    form.fixedEndTime = that.$common.dateTime(29)[1];
                    break;
                }
            let startTime, endTime;
            if (form.fixedStartTime == '' && form.fixedEndTime == '' && form.startTime == '' && form.endTime == '') {
                startTime = '';
                endTime = '';
            } else {
                form.startTime?startTime = that.$common.format(form.startTime, 'yyyy-MM-dd HH:mm:ss'):startTime = `${form.fixedStartTime} 00:00:00`;
                form.endTime?endTime = that.$common.format(form.endTime, 'yyyy-MM-dd 23:59:59'):endTime = `${form.fixedEndTime} 23:59:59`;
            }
            let data = {
                currentPage: val,
                endTime: endTime,
                memberId: that.$common.getUser().user_id || '',
                pageSize: 10,
                startTime: startTime
            };
            that.$http.post(that.$api.memberAllowanceRecord,data,true).then((res) => {
                if(res){
                    that.totalBetValid = that.$common.setNumFixed(res.data.totalBetValid,2);
                    that.totalAllowance = that.$common.setNumFixed(res.data.totalAllowance,2);
                    if(res.data.totalRecords > 0){
                        if (res.data.totalRecords > 10) {
                            that.total = res.data.totalRecords;
                        } else {
                            that.total = 0;
                        }
                        res.data.content.map((item) => {
                            item.memberName = that.mask(item.memberName,2);
                            item.registerDate = that.$common.conversionTime(item.registerDate);
                        });
                        that.tableData = res.data.content;
                        that.nothingShow = false;
                    }else{
                        that.tableData = [];
                        that.nothingShow = true;
                        that.total = 0;
                    }
                }else{
                    that.tableData = [];
                    that.total = 0;
                    that.nothingShow = false;
                }
            });
        },
        //会员
        validMemberCount() {
            this.$http.get(this.$api.validMemberCount).then((res) => {
                if (res) {
                    if (res.code === 15061){
                        this.$message.warning(res.msg);
                        return
                    }
                    this.effectiveVnum = res.data.validMemberCount;
                    this.Vnum = res.data.allMemberCount;
                    this.availableAmount(this.effectiveVnum);
                }
            });
        },
        // 下载二维码
        download() {
            let dataUrl = document.querySelector('#qrcode').querySelector('img').src;
            this.downloadURI(dataUrl, 'qrcode.png');
        },
        downloadURI(uri, name) {
            var link = document.createElement('a');
            link.download = name;
            link.href = uri;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        backPage() {
            this.rulesShow = false;
        },
        // 获取规则
        toRules() {
            this.title = this.$t('highRebate.text13');
            this.rulesShow = true;
            this.$http.get(this.$api.allowanceExplain).then((res) => {
                this.rules = res.data.explains;
            });
        },
        toVip() {
            this.title = this.$t('highRebate.text14');
            this.rulesShow = true;
            this.query(1);
        },
        // 推广码
        referralLink() {
            let that = this;
            that.$http.get(that.$api.referralLink).then((res) => {
                document.getElementById('qrcode').innerHTML = '';
                if (res.code === 15061) {
                    this.$message.warning(res.msg);
                    return
                }
                that.inviteCode = res.data.code;
                that.promoteAddress = `${window.location.origin}?code=${that.inviteCode}`;
                new QRCode('qrcode', {
                    'width': 180, // 设置宽度，单位像素
                    'height': 180, // 设置高度，单位像素
                    'text': that.promoteAddress, // 设置二维码内容或跳转地址
                });
            });
        },
        // 可领取金额
        availableAmount(effectiveVnum) {
            let that = this;
            that.$http.post(that.$api.availableAmount).then((res) => {
                if (res.code === 0) {
                    that.meetConditions = res.data.minValidCount;//符合领取要求会员人数
                    that.maxReceive = that.$common.setNumFixed(res.data.maxReceive,2);//领取上限金额
                    that.minCount = that.$common.setNumFixed(res.data.minCount,2);
                    that.amount = that.$common.setNumFixed(res.data.allowance,2);
                    that.ultiple = res.data.auditFactor;
                    if (that.amount - 0 >= that.minCount - 0 && +effectiveVnum >= that.meetConditions && that.amount - 0 <= that.maxReceive - 0) {
                        that.receiveFalse = true;
                    } else {
                        that.receiveFalse = false;
                    }
                }
            });
        },
        cancel() {
            this.dialogVisible = false;
        },
        // 点击领取按钮
        getReceive() {
            if (this.receiveFalse) {
                this.dialogVisible = true;
            } else {
                this.$message.error(
                    `${this.$t("highRebate.messageErr1")}
                    ${this.minCount}
                    ${this.$t("highRebate.messageErr2")}
                    ${this.meetConditions}
                    ${this.$t("highRebate.messageErr3")}
                    ${this.maxReceive}
                    ${this.$t("highRebate.text2")}
                    `);
            }
        },
        // 领取
        determine() {
            let that = this;
            that.$http.post(that.$api.getReceive).then((res) => {
                if (res.code == 0) {
                    that.$message({
                        'message': that.$t('highRebate.text30'),
                        'type': 'success',
                    });
                    that.availableAmount(that.effectiveVnum);
                    that.dialogVisible = false;
                    // eslint-disable-next-line vue/custom-event-name-casing
                    that.$emit('trigger');
                } else {
                    let msg =
            that.$t(`errorCode.${res.code}`) + `(${res.code})` ||
            that.$t("errorCode.webDefault");
                    that.$http.errMsg(msg);
                }
            });
        },
        // 复制推广码
        onCopyResult(type) {
            if (type === 'success') {
                this.$message({
                    message: this.$t('record.text5'),
                    type: 'success',
                });
            } else {
                this.$message.error(this.$t('record.text6'));
            }
        },
        // 复制地址
        onCopyResults(type) {
            if (type === 'success') {
                this.$message({
                    message: this.$t('record.text5'),
                    type: 'success',
                });
            } else {
                this.$message.error(this.$t('record.text6'));
            }
        },
    },
}
</script>
<style lang="less">
@import url('./record.css');
    .highRebate{
        .receivePart{
            height: 97px;
            width: 90%;
            border-top: 1px solid #F7F7F7;
            border-bottom: 1px solid #F7F7F7;
            margin-top: 25px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .headerLeft,.headerRight{
                width: 50%;
            }
            .headerLeft{
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .receivePartLeft{
                display: flex;
                justify-content: space-between;
                align-items: center;
                .text1{
                    font-size: 14px;
                    .textLeft{
                        color: #333333;
                    }
                    .textRight{
                        color:#E91919;
                    }
                }
                .text2{
                    color: #999999;
                    font-size: 14px;
                    margin-top: 13px;
                }
            }
            .receive{
                background: #E91919;
                color: #ffffff;
                cursor: pointer;
                width: 83px;
                height: 33px;
                border-radius: 21px;
                text-align: center;
                line-height: 33px;
                font-size: 14px;
                margin-right: 25px;
                &:hover{
                    opacity: 0.9;
                }
            }
        }

        .VipNum{
            cursor: pointer;
            width: 90%;
            height: 60px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-left: 1px solid #F7F7F7;
            .VipNumLeft{
                font-size: 16px;
                color: #333333;
                margin-left: 14px;
            }
            i{
                width: 9px;
                height: 17px;
                display: inline-block;
                background: url('../../../assets/images/xf/rirightIconGray.png') no-repeat;
                background-size: 100% 100%;
            }
        }

        .qrCode{
            display: flex;
            flex-wrap: nowrap;
            width: 90%;
            justify-content: space-between;
            margin-top: 22px;
            .item{
                display: flex;
                flex-direction: column;
                align-items: center;

                .bgcwhite{
                    width: 250px;
                    height: 250px;
                    background: #FFFFFF;
                    border: 1px solid #DCDCDC;
                    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
                    opacity: 1;
                    border-radius: 8px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .bgcBorder{
                        width: 180px;
                        height: 180px;
                        background: url('../../../assets/images/xf/qrcodeBorder.png') no-repeat;
                        background-size: 100% 100%;
                        padding: 20px;
                        box-sizing: border-box;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    .InviteCode{
                        font-size: 24px;
                        color:#E91919;
                    }
                    .address{
                        color: #313131;
                        font-size: 16px;
                    }
                    .text1{
                        font-size: 16px;
                        color: #313131;
                        margin-top: 10px;
                    }

                }
                .qrcodeButton{
                    cursor: pointer;
                    width: 133px;
                    height: 33px;
                    background: #E91919;
                    box-shadow: 0px 3px 6px rgba(230, 79, 79, 0.16);
                    opacity: 1;
                    border-radius: 17px;
                    text-align: center;
                    line-height: 33px;
                    color: #fff;
                    font-size: 14px;
                    margin-top: 20px;
                }
            }

        }
        .rules{
            margin-top: 32px;
            height: 68px;
            border-top: 1px solid #F7F7F7;
            border-bottom: 1px solid #F7F7F7;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            i{
                width: 9px;
                height: 17px;
                display: inline-block;
                background: url('../../../assets/images/xf/rirightIconGray.png') no-repeat;
                background-size: 100% 100%;
            }
        }
        //规则详情
        .rulesDetails{
            table{
                width: 100% !important;
                margin-top: 5px;
                tr{
                    height: 30px !important;
                }
            }
            p{
                margin-top: 5px;
            }
            span{
                display: inline-block;
                width: 100% !important;
                display: flex;
                img{
                    margin: 0 auto;
                }
            }
        }

        //邀请会员
        .gameRecordTitle{
            color: #333333;
            font-size: 14px;
            font-weight: bold;
            margin-top: 25px;
        }
        .textOne{
            color: #313131;
            font-size: 14px;
            padding: 15px 0;
            border-top: 1px solid #E0DACD;
            box-sizing: border-box;
            margin: 50px 0;
            opacity: 0.5;
        }
        .line{
            width: 20px;
            height: 1px;
            border-top: 1px solid #313131;
            margin: 0 10px;
        }
        .transactionStyle{
            display: flex;
            flex-wrap: wrap;
            span{
                width: 107px;
                height: 34px;
                border: 1px solid #CCCCCC;
                text-align: center;
                line-height: 34px;
                margin-right: 10px;
                border-radius: 25px;
                color: #333333;
                cursor: pointer;
                &:hover {
                    background: #E91919;
                    color: #ffffff;
                    border-color: #E91919;
                }
            }
            .buttonColor{
                background: #E91919;
                color: #ffffff;
                border-color: #E91919;
            }
        }
        .copybutton {
            border: none;
            color: #E91919;
            background: none;
            padding: 0 5px;
            font-size: 0.14rem !important;
            padding-top: 0.02rem;

        }
        .betNo{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 1.3rem;
            font-size: 0.14rem !important;
        }
        .borderBottom{
            height: 1px;
            background: #CDD8E0;
            margin-top: 23px;
        }

        .pagination{
            width: 100%;
            margin-top: 15px;
            display: flex;
            justify-content: flex-end;
        }
        .totalBet{
            color: #313131;
            font-size: 16px;
            margin: 60px 0;
            .totalBetLeft{
                margin-right: 65px;
            }
        }
        .el-table::before{
            height: 0;
        }
    }
</style>
<style lang="less">
.receive{
    .el-dialog {
        min-width: 426px;
        padding-bottom: 10px;
        box-sizing: border-box;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        margin-top: 0 !important;
        .el-dialog__body {
            padding: 0;
            height: 100%;
        }
        .el-button {
            padding: 0;
        }
    }
    p{
        margin-top: 10px;
        text-align: center;
    }
    .p1{
        color: #333333;
        font-size: 32px;
        margin-top: 20px;
    }
    .p2{
        color: #2D2B4D;
        font-size: 14px;
        font-weight: 500;
    }
    .p3{
        color: #1D1717;
        font-size: 18px;
        font-weight: 500;
    }
    .p4{
        color: #A7A7A7;
        font-size: 14px;
        font-weight: 500;
    }
    .title {
        height: 0.55rem;
        box-sizing: border-box;
        border-radius: 0.1rem 0.1rem 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.28rem;
        padding-top: 0.32rem;
        color: #333333;
        font-weight: bold;
    }
    .el-dialog__close {
        font-size: 0.3rem;
    }
    .footer-button {
        display: flex;
        justify-content: space-around;
        margin: 20px 0;
        .el-button {
            width: 131px;
            height: 46px;
            text-align: center;
            font-size: 14px;
            font-weight: 500;
            border: none;
            border-radius: 22px;
        }
        .button-left {
            margin-left: 40px;
            border: 1px solid #E91919;
            color: #E91919;
            &:hover{
                background-color: #ffffff;
            }
        }
        .button-right {
            margin-right: 0.4rem;
            color: #ffffff;
            background: #E91919;
        }
        
    }
    .el-dialog__header {
        padding: 0;
    }
    .dialogClose {
        width: 17px;
        height: 17px;
        position: absolute;
        top: 0.14rem;
        right: 0.14rem;
        transition: 1s;
    }
    .el-button--primary{
        border: none;
    }
    
}

</style>
